import { Backdrop } from '@mui/material';
import { useIsMutating } from '@tanstack/react-query';
import { SVLoader } from './core';

type MutationOverlayProps = {
  isTest?: boolean;
};

export default function MutationOverlay({
  isTest = false,
}: MutationOverlayProps) {
  const isMutating = useIsMutating() >= 1 || isTest;

  return (
    <Backdrop open={isMutating} sx={{ zIndex: 9999 }}>
      <SVLoader />
    </Backdrop>
  );
}
